'use client';

import { useMemo } from 'react';
import Link from 'next/link';
import { useQuery } from '@apollo/client/react';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { sidebarCityGroupsQuery } from '../../apollo/groups';
import { useAppContext } from '../../contexts/app';
import { buildImageUrl } from '../../utils/images';

const SidebarActiveGroups = () => {
  const { city } = useAppContext();

  const { data } = useQuery(sidebarCityGroupsQuery, {
    variables: { slug: city?.slug ?? '' },
    skip: !city,
  });

  const groups = useMemo(() => {
    if (!data?.city?.groups) {
      return [];
    }
    return [...data.city.groups]
      .filter((group: { upcomingEventsCount: number }) => group.upcomingEventsCount > 0)
      .sort((a: { upcomingEventsCount: number; name: string }, b: { upcomingEventsCount: number; name: string }) =>
        (b.upcomingEventsCount || 0) - (a.upcomingEventsCount || 0) || a.name.localeCompare(b.name),
      );
  }, [data]);

  if (groups.length === 0) {
    return null;
  }

  return (
    <>
      {groups.map((group: { id: string; slug: string; name: string; image: { filename: string } | null }) => (
        <ListItemButton
          key={group.id}
          component={Link}
          href={`/groups/${group.slug}`}
          dense
        >
          <ListItemAvatar sx={{ minWidth: 36 }}>
            {group.image ? (
              <Avatar
                alt={group.name}
                src={buildImageUrl(group.image, '20x20')}
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>
                {group.name.charAt(0)}
              </Avatar>
            )}
          </ListItemAvatar>
          <ListItemText
            primary={group.name}
            slotProps={{ primary: { noWrap: true, variant: 'body2' } }}
          />
        </ListItemButton>
      ))}
    </>
  );
};

export default SidebarActiveGroups;
